import React from "react";
import LeaderProfileDetailsFUHSD from "./LeaderProfileDetailsFUHSD";
import LeaderProfileDetailsRegular from "./LeaderProfileDetailsRegular";

function LeaderProfileDetailsWrapper({ currentLeader, t }) {
  // Check affiliation, default to Regular if not FUHSD
  const affiliation = currentLeader?.owner?.affiliation;
  if (affiliation === "FUHSD") {
    return <LeaderProfileDetailsFUHSD currentLeader={currentLeader} t={t} />;
  }
  return <LeaderProfileDetailsRegular currentLeader={currentLeader} t={t} />;
}

export default LeaderProfileDetailsWrapper;
